import { lazy } from 'react'
import BasicLayout from '../components/layout/BasicLayout'
import NothingLayout from '../components/layout/NothingLayout'
import routerConstants from '../constants/routerConstants'
import { CHUC_NANG_PERMISSION_CODES } from '@constants/permissionConstants'

const routePublic: any[] = [
  { path: '/login', name: 'Login', exact: true, layout: NothingLayout, component: lazy(() => import('../components/login/Login')), },
  { path: '/setting-token', name: 'SettingToken', exact: true, layout: NothingLayout, component: lazy(() => import('../components/login/SettingToken')), },
  { path: '/unauthorized', name: 'Unauthorized', exact: true, layout: BasicLayout, component: lazy(() => import('../components/404/Unauthorized')), },
  { path: '/', name: 'Home', exact: true, layout: BasicLayout, component: lazy(() => import('../components/home/Home')), },
  { path: '/developer/contact', name: 'ITContact', exact: true, layout: NothingLayout, component: lazy(() => import('../components/page/ITContact')), },
  { path: '/privacy-policy', name: 'PrivacyPolicy', exact: true, layout: NothingLayout, component: lazy(() => import('../components/page/PrivacyPolicy')), },
]

const routeUser: any[] = [
  { path: routerConstants.user.list, name: 'userList', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/user/UserList')), },
  { path: routerConstants.user.detail, name: 'userDetail', exact: false, layout: BasicLayout, component: lazy(() => import('../components/admin/user/UserDetail')), },
  { path: routerConstants.user.changePWD, name: 'UserChangePWD', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/user/UserChangePWD')), },
]

const generateRoutes = (chucNangAll: string[], webUrls: string[]) => {
  const hasChucNangByCode = (chucNangCode: string): boolean => {
    return chucNangAll.includes(chucNangCode);
  };

  const hasMenu = (url: string): boolean => {
    return webUrls.includes(url);
  };

  const routeApps: any[] = [
    ...routePublic,
    ...routeUser,
  ]

  // customer
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CUSTOMER_LIST)) {
    routeApps.push({ path: routerConstants.customer.list, name: 'customerList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/customer/CustomerList')), title: 'KHÁCH HÀNG' })
  }
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CUSTOMER_ADD)) {
    routeApps.push({ path: routerConstants.customer.add, name: 'customerAdd', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/customer/CustomerAdd')), title: 'THÊM KHÁCH HÀNG' })
  }
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CUSTOMER_EDIT)) {
    routeApps.push({ path: routerConstants.customer.edit, name: 'customerEdit', exact: false, layout: BasicLayout, component: lazy(() => import('@components/manage/customer/CustomerUpdate')), title: 'CẬP NHẬT KHÁCH HÀNG' })
  }
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CUSTOMER_DETAIL)) {
    routeApps.push({ path: routerConstants.customer.detail, name: 'customerDetail', exact: false, layout: BasicLayout, component: lazy(() => import('@components/manage/customer/CustomerDetail')), title: 'CHI TIẾT KHÁCH HÀNG' })
  }

  // category
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CATEGORY_LIST)) {
    routeApps.push({ path: routerConstants.category.list, name: 'categoryList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/category/CategoryList')), title: 'DANH MỤC' })
  }
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CATEGORY_ADD)) {
    routeApps.push({ path: routerConstants.category.add, name: 'categoryAdd', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/category/CategoryAdd')), title: 'THÊM DANH MỤC' })
  }
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CATEGORY_EDIT)) {
    routeApps.push({ path: routerConstants.category.edit, name: 'categoryEdit', exact: false, layout: BasicLayout, component: lazy(() => import('@components/manage/category/CategoryUpdate')), title: 'CẬP NHẬT DANH MỤC' })
  }

  // product
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRODUCT_LIST)) {
    routeApps.push({ path: routerConstants.product.list, name: 'productList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/product/ProductList')), title: 'SẢN PHẨM' })
  }
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRODUCT_ADD)) {
    routeApps.push({ path: routerConstants.product.add, name: 'productAdd', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/product/ProductAdd')), title: 'THÊM SẢN PHẨM' })
  }
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRODUCT_EDIT)) {
    routeApps.push({ path: routerConstants.product.edit, name: 'productEdit', exact: false, layout: BasicLayout, component: lazy(() => import('@components/manage/product/ProductUpdate')), title: 'CẬP NHẬT SẢN PHẨM' })
  }
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRODUCT_DETAIL)) {
    routeApps.push({ path: routerConstants.product.detail, name: 'productDetail', exact: false, layout: BasicLayout, component: lazy(() => import('@components/manage/product/ProductDetail')), title: 'CHI TIẾT SẢN PHẨM' })
  }

  // order
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_ORDER_COMMON_DETAIL)) {
    routeApps.push({ path: routerConstants.order.detail, name: 'orderDetail', exact: false, layout: BasicLayout, component: lazy(() => import('@components/manage/order/OrderDetail')), title: 'CHI TIẾT ĐƠN HÀNG' })
  }

  // tất cả đơn hàng
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_ORDER_ALL_LIST)) {
    routeApps.push({ path: routerConstants.order.donHangAll, name: 'orderAllList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/order/orderManage/AllOrderList')), title: 'TẤT CẢ ĐƠN HÀNG' })
  }

  // gán nhân viên
  if (hasMenu(routerConstants.order.donHangManage)) {
    routeApps.push({ path: routerConstants.order.donHangManage, name: 'orderManageList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/order/orderManage/ManageOrderList')), title: 'GÁN NHÂN VIÊN' })
  }

  // nhat hang
  if (hasMenu(routerConstants.order.donHangPick)) {
    routeApps.push({ path: routerConstants.order.donHangPick, name: 'orderPickList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/order/picks/PickOrderList')), title: 'NHẶT HÀNG' })
  }

  // kiem hang
  if (hasMenu(routerConstants.order.donHangCheck)) {
    routeApps.push({ path: routerConstants.order.donHangCheck, name: 'orderCheckList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/order/checks/CheckOrderList')), title: 'KIỂM TRA' })
  }

  // dong goi
  if (hasMenu(routerConstants.order.donHangPack)) {
    routeApps.push({ path: routerConstants.order.donHangPack, name: 'orderPackList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/order/packs/PackOrderList')), title: 'ĐÓNG GÓI' })
  }

  // dieu phoi
  if (hasMenu(routerConstants.order.donHangSchedule)) {
    routeApps.push({ path: routerConstants.order.donHangSchedule, name: 'orderScheduleList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/order/schedules/ScheduleOrderList')), title: 'ĐIỀU PHỐI' })
  }

  // giao hang
  if (hasMenu(routerConstants.order.donHangShip)) {
    routeApps.push({ path: routerConstants.order.donHangShip, name: 'orderShipList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/order/ships/ShipOrderList')), title: 'GIAO HÀNG' })
  }
  
  // đồng bộ
  if (hasMenu(routerConstants.order.donHangSync)) {
    routeApps.push({ path: routerConstants.order.donHangSync, name: 'orderSyncList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/manage/order/orderManage/SyncOrderList')), title: 'ĐỒNG BỘ' })
  }

  // report
  if (hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_REPORT_LIST)) {
    routeApps.push({
      path: routerConstants.report.list,
      name: 'reportList',
      exact: true,
      layout: BasicLayout,
      component: lazy(() => import('@components/manage/report/ReportList')),
      title: 'BÁO CÁO CHI TIẾT',
    })
    routeApps.push({
      path: routerConstants.report.orderList,
      name: 'reportOrderList',
      exact: true,
      layout: BasicLayout,
      component: lazy(() => import('@components/manage/report/ReportOrderList')),
      title: 'BÁO CÁO ĐƠN HÀNG',
    })
  }

  // đồng bộ kiot
  if (hasMenu(routerConstants.syncKiot.sync)) {
    routeApps.push({ path: routerConstants.syncKiot.sync, name: 'syncKiotList', exact: true, layout: BasicLayout, component: lazy(() => import('@components/admin/syncKiot/SyncKiot')), title: 'ĐỒNG BỘ KIOT' })
  }

  // Kiot retailer — cập nhật đăng nhập sale
  if (hasMenu(routerConstants.kiotRetailer.saleLogin) || hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_DUAN_MANGE)) {
    routeApps.push({
      path: routerConstants.kiotRetailer.saleLogin,
      name: 'kiotRetailerSaleLogin',
      exact: true,
      layout: BasicLayout,
      component: lazy(() => import('@components/admin/kiotRetailer/KiotRetailerSaleLogin')),
      title: 'ĐĂNG NHẬP KIOT (SALE)',
    })
  }

  // Chi nhánh — logo, địa chỉ và thông tin liên hệ
  if (hasMenu(routerConstants.chiNhanh.capNhatThongTin) || hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CHINHANH_MANGE)) {
    routeApps.push({
      path: routerConstants.chiNhanh.capNhatThongTin,
      name: 'chiNhanhCapNhatThongTin',
      exact: true,
      layout: BasicLayout,
      component: lazy(() => import('@components/admin/chiNhanh/ChiNhanhThongTinUpdate')),
      title: 'THÔNG TIN CHI NHÁNH',
    })
  }

  return routeApps;
};

export const fallbackRoutes = routePublic;

export default generateRoutes
